var adjustoverflowMenu, flexObjects, resizeTimeout;

flexObjects = [];

resizeTimeout = void 0;

adjustoverflowMenu = function() {
  $(flexObjects).each(function() {
    $(this).overflowMenu({
      'undo': true
    }).overflowMenu(this.options);
  });
};

$(window).resize(function() {
  window.clearTimeout(resizeTimeout);
  resizeTimeout = window.setTimeout((function() {
    adjustoverflowMenu();
  }), 200);
});

$.fn.overflowMenu = function(options) {
  var checkFlexObject, s;
  checkFlexObject = void 0;
  s = $.extend({
    'threshold': 2,
    'cutoff': 0,
    'linkText': 'more&hellip;',
    'linkTitle': 'View More',
    'linkTextAll': 'actions&hellip;',
    'linkTitleAll': 'Open/Close Menu',
    'undo': false
  }, options);
  this.options = s;
  checkFlexObject = $.inArray(this, flexObjects);
  if (checkFlexObject >= 0) {
    flexObjects.splice(checkFlexObject, 1);
  } else {
    flexObjects.push(this);
  }
  return this.each(function() {
    var $firstItem, $items, $lastChild, $lastItem, $menu, $moreItem, $popup, $this, allInPopup, button, firstItemHeight, firstItemTop, i, keepLooking, li, needsMenu, numItems, numToRemove;
    $this = $(this);
    $items = $this.find('> li');
    $firstItem = $items.first();
    $lastItem = $items.last();
    numItems = $this.find('li').length;
    firstItemTop = Math.floor(($firstItem.offset() || {}).top);
    firstItemHeight = Math.floor($firstItem.outerHeight(true));
    $lastChild = void 0;
    keepLooking = void 0;
    $moreItem = void 0;
    numToRemove = void 0;
    allInPopup = false;
    $menu = void 0;
    i = void 0;
    needsMenu = function($itemOfInterest) {
      var result;
      if ($itemOfInterest.length < 1) {
        return false;
      }
      result = Math.ceil($itemOfInterest.offset().top) >= firstItemTop + firstItemHeight ? true : false;
      return result;
    };
    if (needsMenu($lastItem) && numItems > s.threshold && !s.undo && $this.is(':visible')) {
      $popup = $('<ul class="dropdown-menu"></ul>');
      i = numItems;
      while (i > 1) {
        $lastChild = $this.find('> li:last-child');
        keepLooking = needsMenu($lastChild);
        $lastChild.appendTo($popup);
        if (i - 1 <= s.cutoff) {
          $($this.children().get().reverse()).appendTo($popup);
          allInPopup = true;
          break;
        }
        if (!keepLooking) {
          break;
        }
        i--;
      }
      if (allInPopup) {
        button = $("<a role='button' href='#' title='" + s.linkTitleAll + "'>" + s.linkTextAll + " <svg class='cyclops-icon'><use xlink:href='#icon-caret-down'></svg></a>");
      } else {
        $popup.addClass('dropdown-menu-right');
        button = $("<a role='button' href='#' title='" + s.linkTitle + "'>" + s.linkText + " <svg class='cyclops-icon'><use xlink:href='#icon-caret-down'></svg></a>");
      }
      button.dropdown();
      li = $('<li class="dropdown overflow-menu"></li>');
      li.append(button);
      $this.append(li);
      $moreItem = $this.find('> li.overflow-menu');
      if (needsMenu($moreItem)) {
        $this.find('> li:nth-last-child(2)').appendTo($popup);
      }
      $popup.children().each(function(i, li) {
        $popup.prepend(li);
      });
      $moreItem.append($popup);
    } else if (s.undo && $this.find('ul.dropdown-menu')) {
      $menu = $this.find('ul.dropdown-menu');
      numToRemove = $menu.find('li').length;
      i = 1;
      while (i <= numToRemove) {
        $menu.find('> li:first-child').appendTo($this);
        i++;
      }
      $menu.remove();
      $this.find('> li.dropdown').remove();
    }
  });
};
